import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Event from './Event';
import { fetchAllEvents, getFormattedTime } from '../utils';
import { setEvents } from '../actions/events';
import { setTodaysDate } from '../actions/today';
import { mapDate } from '../actions/map';
import FilteredItem from './FilteredItem';
var Events = function Events(props) {
  var _props$selectedFilter;
  var dispatch = useDispatch();
  var loadingEvents = useSelector(function (state) {
    return state.loadingEvents;
  });
  var events = useSelector(function (state) {
    return state.events;
  });
  var selectedTestDay = useSelector(function (state) {
    return state.selectedTestDay;
  });
  useEffect(function () {
    console.log('Welcome to Jewelry Week!');
    setInterval(function () {
      return dispatch(setTodaysDate(new Date()));
    }, 60000);
    fetchAllEvents().then(function (events) {
      dispatch(setEvents(events));
    })["catch"](function (error) {
      return console.error(error);
    });
  }, []);
  var renderEvents = useMemo(function () {
    var selectedFilters = props === null || props === void 0 ? void 0 : props.selectedFilters;
    var filteredEvents = [];
    if (events) {
      var _selectedFilters$loca;
      filteredEvents = events.filter(function (evt) {
        if (selectedFilters.option === 'virtual' && !evt.virtual || selectedFilters.option !== 'virtual' && evt.virtual) return false;
        var isFiltered = true;
        if (selectedFilters.date.length) {
          isFiltered = evt.dates ? evt.dates.find(function (date) {
            return selectedFilters.date.includes(date.date);
          }) !== undefined : false;
        }
        if (selectedFilters.types.length) {
          if (evt.event_types) {
            if (evt.event_types.filter(function (etype) {
              return selectedFilters.types.includes(etype.slug);
            }).length < 1) {
              isFiltered = false;
            }
          } else {
            isFiltered = false;
          }
        }
        return isFiltered;
      });
      if ((selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca = selectedFilters.location) === null || _selectedFilters$loca === void 0 ? void 0 : _selectedFilters$loca.length) > 0) {
        filteredEvents = filteredEvents.filter(function (it) {
          var _selectedFilters$loca2;
          return (selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca2 = selectedFilters.location) === null || _selectedFilters$loca2 === void 0 || (_selectedFilters$loca2 = _selectedFilters$loca2.filter(function (_it) {
            var _it$neighborhood;
            return (_it === null || _it === void 0 ? void 0 : _it.value) === (it === null || it === void 0 || (_it$neighborhood = it.neighborhood) === null || _it$neighborhood === void 0 ? void 0 : _it$neighborhood.value);
          })) === null || _selectedFilters$loca2 === void 0 ? void 0 : _selectedFilters$loca2.length) > 0;
        });
      }

      // filteredEvents = filteredEvents.filter(evt => (evt.dates || []).length > 0);

      // make it so that events with end date that is before now get moved to the bottom of the list of events
      var _today = new Date();
      var todayDate = selectedTestDay ? selectedTestDay : "".concat(_today.getFullYear(), "-").concat(_today.getMonth() + 1, "-").concat(_today.getDate());
      var nowTime = getFormattedTime();
      var eventsWithEndDateAfterNow = [];
      var eventsWithEndDateBeforeNow = [];
      filteredEvents.forEach(function (evt) {
        if (evt.dates != null) {
          if (evt.dates.length > 0) {
            // if one event_date is not expired
            if (evt.dates.filter(function (it) {
              var eventDate = it.date || it.event_date;
              if (eventDate && it.end_time) {
                if (eventDate > todayDate && it.end_time > nowTime) {
                  return true;
                }
              }
              return false;
            }).length > 0) {
              eventsWithEndDateAfterNow.push(evt);
            } else {
              eventsWithEndDateBeforeNow.push(evt);
            }
          } else {
            eventsWithEndDateAfterNow.push(evt);
          }
        } else {
          eventsWithEndDateAfterNow.push(evt);
        }
      });
      filteredEvents = eventsWithEndDateBeforeNow.concat(eventsWithEndDateAfterNow);
    }
    return filteredEvents;
  }, [events, props === null || props === void 0 ? void 0 : props.selectedFilters, selectedTestDay]);
  console.log('renderEvents: ', renderEvents);
  var today = new Date();
  var todaysDate = selectedTestDay ? selectedTestDay : "".concat(today.getFullYear(), "-").concat(today.getMonth() + 1, "-").concat(today.getDate());
  var weekEndDate = new Date(eventIntros[eventIntros.length - 1]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "btn-mobile-filter",
    onClick: props === null || props === void 0 ? void 0 : props.onShowFilters
  }, "Show filters"), /*#__PURE__*/React.createElement(FilteredItem, props), loadingEvents ? /*#__PURE__*/React.createElement("div", {
    className: "event-loading-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-loading"
  }, "Loading")) : /*#__PURE__*/React.createElement("div", null, renderEvents.length > 0 && (props === null || props === void 0 || (_props$selectedFilter = props.selectedFilters) === null || _props$selectedFilter === void 0 ? void 0 : _props$selectedFilter.option) === 'in-person' && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'none'
    },
    id: "map-current-date"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn",
    onClick: function onClick() {
      return dispatch(mapDate());
    }
  }, "Map this date")), /*#__PURE__*/React.createElement("div", {
    id: "events-wrapper"
  }, renderEvents.length > 0 ? renderEvents.map(function (nycjwEvent, index) {
    var _props$selectedFilter2, _props$selectedFilter4;
    if (nycjwEvent.hide_from_listing) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: nycjwEvent.id
      });
    }
    if ((props === null || props === void 0 || (_props$selectedFilter2 = props.selectedFilters) === null || _props$selectedFilter2 === void 0 || (_props$selectedFilter2 = _props$selectedFilter2.date) === null || _props$selectedFilter2 === void 0 ? void 0 : _props$selectedFilter2.length) > 0) {
      if (nycjwEvent.intro) {
        var _props$selectedFilter3;
        props === null || props === void 0 || (_props$selectedFilter3 = props.selectedFilters) === null || _props$selectedFilter3 === void 0 || (_props$selectedFilter3 = _props$selectedFilter3.date) === null || _props$selectedFilter3 === void 0 || _props$selectedFilter3.filter(function (it) {
          return new Date(todaysDate).getTime() < new Date(it).getTime() || new Date(today).getTime() > new Date(weekEndDate).getTime();
        }).map(function (item) {
          return /*#__PURE__*/React.createElement(React.Fragment, {
            key: nycjwEvent.id
          });
        });
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "event-".concat(index)
    }, /*#__PURE__*/React.createElement(Event, {
      key: "event-".concat(index),
      nycjwEvent: nycjwEvent,
      eventType: props === null || props === void 0 || (_props$selectedFilter4 = props.selectedFilters) === null || _props$selectedFilter4 === void 0 ? void 0 : _props$selectedFilter4.option
    }));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "no-events"
  }, /*#__PURE__*/React.createElement("p", null, "No events")))));
};
export default Events;